import { BrowserTracing } from '@sentry/tracing'
import * as Sentry from 'dida-sentry-vue-sdk'
import { VnToast, BsGetEnv, BsUtil, BsTrack, BsTrackExp, BsTrackwaitTime } from 'dida-web-common'
import { addStat } from './utils/stat.util'
import packageInfo from '../package.json'
import Vue from 'vue'
import App from './App.vue'
import GLOBALDATA from './globaldata'
import router from './router'
import './index.scss'
import { getAppClient } from '@/utils/environment.util'
const app_lient = getAppClient()
const appId = BsUtil.queryString('appId') || ''


Vue.use(VnToast)
// import * as Sentry from 'dida-sentry-vue-sdk'
// import { BrowserTracing } from '@sentry/tracing'
// import packageInfo from '../package.json'
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    release: packageInfo.name + '@' + packageInfo.version,
    environment: BsGetEnv.isEnvOnline ? 'online' : (BsGetEnv.isEnvECS ? 'simu' : 'test'),
    dsn: 'https://ee533f399d4a475f9406c28d926c9a2b@sentry.didapinche.com/12',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
      })
    ],
    tracesSampleRate: 1.0
  })
}

Vue.config.productionTip = false


// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     Vue,
//     release: packageInfo.name + '@' + packageInfo.version,
//     environment: BsGetEnv.isEnvOnline ? 'online' : (BsGetEnv.isEnvECS ? 'simu' : 'test'),
//     dsn: 'https://14618095657f4b9eb491dbe810dfaddf@sentry.didapinche.com/10',
//     integrations: [
//       new BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//         tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
//       })
//     ],
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0
//   })
// }

Object.assign(GLOBALDATA, BsGetEnv)
GLOBALDATA.pageSource = BsUtil.queryString('source') || '' // 渠道来源
GLOBALDATA.statStrPre = `${GLOBALDATA.pageSource ? ('[' + GLOBALDATA.pageSource + ']') : ''}乘车卡` // 埋点前缀
GLOBALDATA.isIPX = BsGetEnv.isiPhone && window.screen.height >= 812

var cid = BsUtil.queryString('cid') || BsUtil.queryString('user_cid') || BsUtil.queryString('userCid') || BsUtil.queryString('encrypted_cid') || sessionStorage.getItem('cid') || ''
var goods_id = BsUtil.queryString('goods_id')
var source = BsUtil.queryString('source') || ''
var sourcestr = source ? '[' + source + ']乘车卡-' : '乘车卡-'
const statStr = sourcestr + goods_id + '-查看商品'

window.myTrack = new BsTrack({
  name: statStr
}, {}, [
  BsTrackExp,
  BsTrackwaitTime
])

export default new Vue({
  el: '#root',
  components: { App },
  data() {
    return {
      envir: '',
      appId
    }
  },
  async created() {
    this.envir = await getEnvir()
    setTimeout(() => {
      const statStr = '乘车卡-' + BsUtil.queryString('goods_id') + '-详情页'
      const ad_position = BsUtil.queryString('ad_position') || ''
      addStat(statStr, cid, this.envir, ad_position) // 添加埋点
    }, 500)
  },
  router,
  render: h => h(App)
})

async function getEnvir() {
  if (BsGetEnv.inApplication) {
    // app内
    return 'app'
  } else if (BsGetEnv.inWechat || getAppClient(true)) {
    return await new Promise((resolve, reject) => {
      app_lient.getEnv((res) => {
        let result = ''
        if (res.miniprogram) {
          result = BsGetEnv.inWechat ? 'minipg' : 'miniali'
        } else {
          result = BsGetEnv.inWechat ? 'wxh5' : 'alih5'
        }
        return resolve(result)
      })
    })
  } else {
    return 'h5'
  }
}
